import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./notificationTab.scss";
import { getAllNotifications } from "./services";
import { timeSince } from "../../utils/EllowUtils";
// interface to declare all our prop types

const NotificationTab = (props: any) => {
  const [notificationItems, SetNotificationItems] = useState([]);
  const navigate = useNavigate();

  const getNotificationList = (loginId: any) => {
    getAllNotifications(loginId).then((response: any) => {
      if (response && response.status === "success") {
        SetNotificationItems(response.data);
      }
    });
  };

  useEffect(() => {
    let loginId = localStorage.getItem("loginId");
    getNotificationList(loginId);
    const intervalCall = setInterval(() => {
      getNotificationList(loginId);
    }, 5000);
    return () => {
      // clean up
      clearInterval(intervalCall);
    };

  }, []);

  const closeHandle = () => {

    props.setshowNotificationTab(!props.showNotificationTab);
  }

  const handleClick = (redirectionParams: any, notificationsId: any) => {
    var url = redirectionParams.url;

    if (url == '/createResources') {

      navigate('/createResources', {
        state: {
          candidateLoginId: redirectionParams.supportedParams.candidateLoginId, tab: 4,
          notificationsId: notificationsId
        }
      });
    }

    if (url == '/position-details') {
      navigate('/position-details', {
        state: {
          jobId: redirectionParams.supportedParams.jobId,
          positionName: redirectionParams.supportedParams.positionName,
          companyName: redirectionParams.supportedParams.companyName,
          notificationsId: notificationsId
        }
      })
    }

    if (url == '/company') {
      navigate('/company', {
        state: {
          data: {
            companyId: redirectionParams.supportedParams.companyId,
            companyType: redirectionParams.supportedParams.companyType,
            notificationsId: notificationsId
          }
        }
      })
    }
  };
  return (
    <div className="notificationtab">
      <div className="notification-heading">
        <h2>Notifications </h2>
        <button onClick={closeHandle} className="k-button k-button-md k-button-flat k-button-flat-base k-rounded-md k-icon-button k-window-action k-dialog-action"><span role="presentation" className="k-button-icon k-icon k-i-x"></span></button>
      </div>
      <div className="notification-body">
        {notificationItems.length == 0 && <div className="noresult">No Notification found</div>}
        {notificationItems && notificationItems.map((notificationItem: any) => {
          // if(notificationItem.status)
          // {
          return (<div className="notificationItems" key={notificationItem.notificationsId} onClick={() => handleClick(notificationItem.redirectionParams, notificationItem.notificationsId)}>
            <div>
              <p className="notification-title" >{notificationItem.heading}  <span>{timeSince(notificationItem.createdOn)}</span></p>

            </div>
            <p className="notification-description">{notificationItem.message}</p>
          </div>)
          // }
        })}


      </div>
    </div>
  );
};

export default NotificationTab;


